import { observer } from 'mobx-react';
import * as React from 'react';
import { Tooltip } from 'react-tooltip';
import clickOutsideStore from '../../ClickOutsideStore';
import { useOpenable } from '../Modal/UseOpenable';

interface Props {
  trigger: React.ReactNode;
  children: React.ReactNode;
}

function LightModeTooltip({ trigger, children }: Props) {
  const { modalState, close, open } = useOpenable();
  const tooltipRef = React.createRef<HTMLDivElement>();
  const id = React.useRef(Math.random().toString()).current;
  clickOutsideStore.addListener({ ref: tooltipRef, callback: close });

  return (
    <div ref={tooltipRef}>
      <button data-tooltip-id={id} onClick={open}>
        {trigger}
      </button>
      <Tooltip
        id={id}
        place="bottom"
        className="rounded-lg z-10 border border-gray-300 text-[100%]"
        classNameArrow="border-t border-l border-gray-300"
        border="custom"
        opacity={1}
        clickable
        isOpen={modalState.kind === 'open'}
        variant="light"
      >
        {children}
      </Tooltip>
    </div>
  );
}

export default observer(LightModeTooltip);
